import React, { useEffect, useMemo } from 'react';
import { Connector, useAccount, useConnect } from 'wagmi';
import { observer } from 'mobx-react-lite';
import { wagmiStore } from '../wagmi.store';
import Button from '../../../ui/button';
import useImage from '../../../hooks/useImage';
import styles from './styles.module.scss';

export const WalletOptions = observer(() => {
  const {
    onStatus,
    connectConnector,
    generateNonceAndSign,
    connectOpt,
    connectorName,
  } = wagmiStore;
  const { connectors, error = '', isPending, connectAsync } = useConnect();
  const { address, isConnected } = useAccount();

  useEffect(() => onStatus(error, isPending), [error, isPending]);

  useEffect(() => {
    isConnected && address && generateNonceAndSign(address);
  }, [isConnected, address]);

  const onLogin = (connector: Connector) => {
    isConnected
      ? generateNonceAndSign(address)
      : connectConnector(connectAsync, connector);
  };

  return (
    <>
      <div className={styles.walletOptions}>
        {connectors.map((connector: Connector) => (
          <WalletOption
            key={connector.uid}
            connector={connector}
            onClick={() => onLogin(connector)}
          />
        ))}
      </div>
      {connectOpt[connectorName]?.error && (
        <div className="errorText errorSection">
          {connectOpt[connectorName].error}
        </div>
      )}
    </>
  );
});

const WalletOption = observer(
  ({ connector, onClick }: { connector: Connector; onClick: () => void }) => {
    const { connectOpt } = wagmiStore;
    const [ready, setReady] = React.useState(false);
    const icons: { [key: string]: string } = {
      MetaMask: useImage('logos/metamask.svg').image,
      WalletConnect: useImage('logos/wallet.png').image,
      loading: useImage('logos/loader.svg').image,
    };
    React.useEffect(() => {
      (async () => {
        const provider = await connector.getProvider();
        setReady(!!provider);
      })();
    }, [connector]);

    const isPending = useMemo(
      () => connectOpt[connector.name]?.pending,
      [connectOpt],
    );

    return (
      <Button
          disabled={isPending}
          type="rounded-15"
          size="w100 lg"
          color="roundedSecondary"
          onClick={onClick}
      >
        <img
            className="buttonImage"
            src={isPending ? icons.loading : icons[connector.name]}
            alt="fastex"
        />
        <span>WalletConnect</span>
      </Button>
    );
  },);
